<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner padding-top-mobile">
      <v-organisation-left-nav />

      <div class="fixed-top d-block d-lg-none">
        <v-organisation-mobile-nav />
      </div>

      <div
        class="layout-container p-3 vh-100 overflow-auto"
        id="organisation-container"
      >
        <v-breadcrumbs
          v-if="breadcrumbs"
          :breadcrumbs="breadcrumbs"
          :home-route="{name: 'organisation-dashboard'}"
        />

        <router-view
          :key="$route.fullPath"
        />
      </div>
    </div>

    <div class="layout-overlay layout-sidenav-toggle"></div>
  </div>
</template>

<script>
import OrganisationLeftNavbar from '@/organisation/components/LeftNavbar.vue';
import OrganisationMobileNavbar from '@/organisation/components/MobileNavbar.vue';
import Breadcrumbs from '@/common/components/Breadcrumbs.vue';
import { pageNotFound } from '@/common/utils/notify';
import { mapGetters } from 'vuex';

export default {
  name: 'OrganisationBase',
  components: {
    'v-breadcrumbs': Breadcrumbs,
    'v-organisation-left-nav': OrganisationLeftNavbar,
    'v-organisation-mobile-nav': OrganisationMobileNavbar,
  },
  data() {
    return {
      showExtra: false,
    };
  },
  computed: {
    ...mapGetters([
      'org',
      'user',
      'breadcrumbs',
    ]),
  },
  created() {
    if (!this.user.primary_organisation) {
      pageNotFound();
      this.$router.push({ name: 'dashboard' });
    }
  },
};
</script>

<style scoped>
@media (max-width: 991px) {
  .padding-top-mobile {
    padding-top: 87px;
  }
}
</style>
